module.exports = __webpack_public_path__ + "img/uploaded-check.02cb3dbc.svg";